import React from 'react';
import { PropTypes } from 'prop-types';

const PageContainer = ({ children }) => (
    <div className="container-fluid px-0" style={{ maxWidth: '1600px' }}>
        {children}
    </div>
);

PageContainer.propTypes = {
    children: PropTypes.any,
};

export default PageContainer;
